export default __webpack_public_path__ + "static/media/blueCloseMenu.f1db98b2.svg";